import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';
import { GenericOldService } from './generic-old.service';
import {PermissionEnum} from "../permission.enum";

const appName = 'control';
const CACHE_SIZE = 1;
const API_ENDPOINT = 'users/permissions';
const REFRESH_INTERVAL = 600000;

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private permissions$: Observable<unknown> | undefined;
  private permissions: unknown | undefined;

  constructor(private resourceService: GenericOldService<unknown>) {}

  getPermissions(): Observable<unknown> {
    if (!this.permissions$) {
      // Set up timer that ticks every X milliseconds
      const timer$ = timer(0, REFRESH_INTERVAL);

      // For each tick make a http request to fetch new data
      this.permissions$ = timer$.pipe(
        switchMap(() => this.requestPermissions()),
        tap(permissions => (this.permissions = permissions)),
        shareReplay({ bufferSize: CACHE_SIZE, refCount: false }),
      );
    }
    return this.permissions$;
  }

  hasPermission(requiredPermissions: PermissionEnum[], resourceName = appName): boolean {
    if (!this.permissions) {
      return false;
    }
    const appPermissions = this.permissions[resourceName.toLowerCase()] ?? [];

    if (!appPermissions.length || !requiredPermissions.length) {
      return false;
    }

    return requiredPermissions.every(permission => appPermissions.includes(permission));
  }

  checkPermissionForEntity(requiredPermissions: PermissionEnum[], resourceName = appName, entityId?: string): Observable<boolean> {
    const params = new URLSearchParams();
    params.append('resource_list', resourceName);
    params.append('operation_list', requiredPermissions.join(','));
    return this.resourceService.get(`${API_ENDPOINT}/${entityId}?${params.toString()}`) as Observable<boolean>;
  }

  private requestPermissions(): Observable<unknown> {
    return this.resourceService.get(API_ENDPOINT);
  }
}
